import { Mail } from "@mui/icons-material";
import { Button } from "@mui/material";
import React from "react";
import RotatingCard from "../../Examples/RotatingCard";

const EmailButton = ({ emailAddress }) => {
  return (
    <RotatingCard>
      <Button variant="contained" href={`mailto:${emailAddress}`}>
        <Mail />
      </Button>
    </RotatingCard>
  );
};

export default EmailButton;
